import React, { useState } from "react";
import {
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import {Link} from 'react-router-dom';


const PAGES = [
  "Home",
  "Courses",
  "Shop",
  "E-books",
  "Coupons",
  "Subscribe",
 
];

const DrawerComp = () => {
  const [OpenDrawer, setOpenDrawer] = useState(false);

  return (
    <React.Fragment>
      <Drawer open={OpenDrawer} onClose={() => setOpenDrawer(false)}>
        <List>
          {PAGES.map((page, index) => (
            <ListItemButton button component={Link} key={index} to={PAGES[index]}>
              <ListItemIcon>
                <ListItemText>{page}</ListItemText>
              </ListItemIcon>
            </ListItemButton>
          ))}
        </List>
      </Drawer>
      <IconButton
        sx={{ marginLeft: "auto" }}
        onClick={() => setOpenDrawer(!OpenDrawer)}
      >
        <MenuIcon sx={{ color: "whitesmoke" }} />
      </IconButton>
    </React.Fragment>
  );
};

export default DrawerComp;
